import React from 'react';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';

import { color, media } from 'styles/utils';

import Button from 'components/Button';
import Container from 'components/Container';
import Horizon from 'components/Horizon';
import Icon from 'components/Icon';
import Stack from 'components/Stack';
import Text from 'components/Text';

const Section = styled.section`
  background-color: ${color('mediumTeal')};
  background-image: linear-gradient(
    ${color('mediumTeal')},
    ${color('darkestTeal')}
  );
  color: ${color('white')};
  position: relative;
  text-align: center;
  padding-block-start: var(--sleuth-safe-area-inset-top, 0);

  & > ${Container} {
    padding: 12rem 0;
    position: relative;
    z-index: 1;
    max-inline-size: min(100%, 100vw - 2rem);
  }

  & > .gatsby-image-wrapper {
    --size-max-block: max(60rem, 100lvh);
    --size-max-inline: 120rem;

    block-size: calc(100% + 10vw);
    inline-size: 100%;
    left: 50%;
    max-block-size: var(--size-max-block);
    max-inline-size: var(--size-max-inline);
    top: 0;
    transform: translateX(-50%);
  }

  ${media.min('120em')} {
    & > .gatsby-image-wrapper {
      mask-image: linear-gradient(
        to right,
        #0000,
        #000 12rem,
        #000 calc(100% - 12rem),
        #0000
      );
    }
  }
`;

export default function Hero() {
  return (
    <Section>
      <StaticImage
        alt="Team group photo"
        layout="fullWidth"
        loading="eager"
        src="../../images/team/team-hero.webp"
        placeholder="blurred"
        style={{ position: 'absolute' }}
      />
      <Container as={Stack} gap="1.75rem" align="center">
        <Text variant="hero" as="h1">
          Engineering efficiency for all
        </Text>
        <Text variant="md">
          From the team that brought Continuous Delivery to Atlassian. Over 50
          years of combined DevOps experience.
        </Text>
        <p>
          <Button to="/careers/" variant="primary">
            Work with us &thinsp; <Icon size="sm" name="arrow-up-right" />
          </Button>
        </p>
      </Container>
      <Horizon />
    </Section>
  );
}
